/**
 * NKBA API
 * The RESTful backend behind the NKBA application
 *
 * OpenAPI spec version: V1.0.0
 * Contact: cloud@nkba.org
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { AxiosRequestConfig } from 'axios';
import { axios } from '../axios.config';

import { ResultsTransactionObjectId } from '../models/ResultsTransactionObjectId';
import { Transaction } from '../models/Transaction';
import { TransactionRequest } from '../models/TransactionRequest';

/* tslint:disable:no-unused-variable member-ordering max-line-length */

export class TransactionApiResource {

    /**
     * Create an adjustment transaction to balance out a transaction
     * 
     * @param body 
     */
    public createAdjustment(body?: Partial<TransactionRequest>, axiosConfig?: AxiosRequestConfig): Promise<Transaction> {
        const reqPath = '/v1/transaction/adjustment';
        let reqConfig = {
            ...axiosConfig,
            method: 'POST',
            url: reqPath,
            data: body
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

    /**
     * Export Great Plains CSV
     * 
     * @param download Download as file
     * @param start Start date
     * @param end End date
     * @param legacy Use legacy exporter
     */
    public exportGreatPlainsCsv(query?: { download?: boolean, start?: string, end?: string, legacy?: boolean }, axiosConfig?: AxiosRequestConfig): Promise<{}> {
        const reqPath = '/v1/transaction/export/greatplains';
        let reqConfig = {
            ...axiosConfig,
            method: 'GET',
            url: reqPath,
            params: query
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

    /**
     * Export payments CSV (bank reconciliation)
     * 
     * @param download Download as file
     * @param start Start date
     * @param end End date
     */
    public exportPaymentsCsv(query?: { download?: boolean, start?: string, end?: string }, axiosConfig?: AxiosRequestConfig): Promise<{}> {
        const reqPath = '/v1/transaction/export/payments';
        let reqConfig = {
            ...axiosConfig,
            method: 'GET',
            url: reqPath,
            params: query
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

    /**
     * Export receivable dues CSV (backout unearned revenue)
     * 
     * @param download Download as file
     * @param start Start date
     * @param end End date
     */
    public exportReceivableDuesCsv(query?: { download?: boolean, start?: string, end?: string }, axiosConfig?: AxiosRequestConfig): Promise<{}> {
        const reqPath = '/v1/transaction/export/receivabledues';
        let reqConfig = {
            ...axiosConfig,
            method: 'GET',
            url: reqPath,
            params: query
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

    /**
     * Return a particular transaction by id
     * 
     * @param id Transaction id
     */
    public getTransaction(id: Partial<string>, axiosConfig?: AxiosRequestConfig): Promise<Transaction> {
        const reqPath = '/v1/transaction/{id}'
                    .replace('{' + 'id}', String(id));
        let reqConfig = {
            ...axiosConfig,
            method: 'GET',
            url: reqPath
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

    /**
     * Return a particular transaction by number
     * 
     * @param num Transaction number
     */
    public getTransactionByNumber(num: Partial<number>, axiosConfig?: AxiosRequestConfig): Promise<Transaction> {
        const reqPath = '/v1/transaction/number/{num}'
                    .replace('{' + 'num}', String(num));
        let reqConfig = {
            ...axiosConfig,
            method: 'GET',
            url: reqPath
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

    /**
     * Return previous transactions, paginated
     * 
     * @param accountId account id to search
     * @param orderId order id to search
     * @param fromAt date to search back from
     * @param from result to paginate from
     * @param limit number of results to return
     */
    public getTransactions(query?: { accountId?: string, orderId?: string, fromAt?: number, from?: string, limit?: number }, axiosConfig?: AxiosRequestConfig): Promise<ResultsTransactionObjectId> {
        const reqPath = '/v1/transaction';
        let reqConfig = {
            ...axiosConfig,
            method: 'GET',
            url: reqPath,
            params: query
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

    /**
     * Create a new Stripe charge transaction
     * 
     * @param body 
     */
    public processCharge(body?: Partial<TransactionRequest>, axiosConfig?: AxiosRequestConfig): Promise<Transaction> {
        const reqPath = '/v1/transaction/charge';
        let reqConfig = {
            ...axiosConfig,
            method: 'POST',
            url: reqPath,
            data: body
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

    /**
     * Process a non-charge payment transaction (check or wire)
     * 
     * @param body 
     */
    public processPayment(body?: Partial<TransactionRequest>, axiosConfig?: AxiosRequestConfig): Promise<Transaction> {
        const reqPath = '/v1/transaction/payment';
        let reqConfig = {
            ...axiosConfig,
            method: 'POST',
            url: reqPath,
            data: body
        };
        return axios.request(reqConfig)
            .then(res => {
                return res.data;
            });
    }

}

export const TransactionApi = new TransactionApiResource();



// WEBPACK FOOTER //
// ./src/common/api/resources/TransactionApi.ts